var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-attachmentsize"},[_c('v-chip',{attrs:{"x-small":"","outlined":"","color":"secondary darken-3"}},[_vm._v(_vm._s(_vm.sizeLong))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }